import profile from '@/config/profile';
import React, { useState, useEffect } from 'react';

const SocialSidebar = () => {
  const [isVisible, setIsVisible] = useState(false);
  const isLightTheme = profile?.theme === 'light';

  useEffect(() => {
    setTimeout(() => setIsVisible(true), 2000);
  }, []);

  return (
    <div className={`fixed left-8 top-1/2 transform -translate-y-1/2 z-40 transition-all duration-1000 ${
      isVisible ? 'translate-x-0 opacity-100' : '-translate-x-20 opacity-0'
    }`}>
      <div className="flex flex-col space-y-6">
        {profile?.socialLinks?.map((social, index) => (
          <div
            key={social.name}
            className={`transition-all duration-500 transform ${
              isVisible ? 'translate-x-0 opacity-100' : '-translate-x-10 opacity-0'
            }`}
            style={{ transitionDelay: `${index * 200 + 2000}ms` }}
          >
            <a
              href={social.href}
              className={`group flex items-center justify-center w-12 h-12 rounded-full border hover:border-blue-500 transition-all duration-300 hover:scale-110 ${
                isLightTheme ? 'bg-white hover:bg-slate-100 border-slate-300 text-slate-900' : 'bg-gray-900 hover:bg-gray-800 border-gray-700 text-white'
              } ${social.color}`}
              aria-label={social.name}
            >
              <span className="text-sm font-bold group-hover:scale-125 transition-transform duration-300">
                {social.icon}
              </span>
              
              {/* Tooltip */}
              <div className={`absolute left-16 text-xs px-3 py-1 rounded opacity-0 group-hover:opacity-100 transition-all duration-300 border whitespace-nowrap ${
                isLightTheme ? 'bg-white text-slate-900 border-slate-300' : 'bg-gray-900 text-white border-gray-700'
              }`}>
                {social.name}
                <div className={`absolute left-0 top-1/2 transform -translate-x-1 -translate-y-1/2 w-2 h-2 rotate-45 border-l border-b ${
                  isLightTheme ? 'bg-white border-slate-300' : 'bg-gray-900 border-gray-700'
                }`}></div>
              </div>
            </a>
          </div>
        ))}
        
        {/* Vertical line */}
        <div className={`w-px h-20 mx-auto transition-all duration-1000 delay-3000 ${
          isLightTheme ? 'bg-slate-300' : 'bg-gray-700'
        } ${
          isVisible ? 'scale-y-100 opacity-100' : 'scale-y-0 opacity-0'
        }`}></div>
      </div>
    </div>
  );
};

export default SocialSidebar;